module.exports = {
  "country": "SI",
  "artist": "Sestre",
  "song": "Samo Ijubezen",
  "year": "2002",
  "place": "13",
  "spotify": "5KSf4Ixupb13qqACBDEUEZ"
};